import { MoonstarCreate } from '../Moonstar/MoonstarCreate';
import { MoonstarCreateForm } from '../Moonstar/MoonstarCreateForm';
import { NudgeInputs, nudgeFormDefaultValues } from './NudgeInputs';

export const NudgeCreate = () => (
  <MoonstarCreate redirect="list">
    <MoonstarCreateForm defaultValues={nudgeFormDefaultValues}>
      <NudgeInputs searchCategories />
    </MoonstarCreateForm>
  </MoonstarCreate>
);
